module.exports = __webpack_public_path__ + "img/logo-ko.56307cac.png";